import printJS from "print-js";
import { api_URL } from "./Constantes";

export const printEtatComptService = (codeExport, selectedYear, selectedJournaux, dateDeb, dateFin, nbcol, niveau, compteDeb, compteFin) => {
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
  const url = `${api_URL}Print/Compta/Etats/${codeExport}/?exercice=${selectedYear}&codeJournal=${selectedJournaux}&dateDeb=${dateDeb}&dateFin=${dateFin}&nbcol=${nbcol}&niveau=${niveau}&compteDeb=${compteDeb}&compteFin=${compteFin}`;

  fetch(url, {
    method: 'GET',
    headers: {
      'user_id': userId,
      'username': username,
    },
  })
    .then(response => response.blob())
    .then(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // Utilisez printJS pour imprimer le PDF
      printJS(fileURL);
    })
    .catch(error => console.error('Erreur lors de la récupération du PDF', error));
};

// /Print/Compta/Etats/blg?exercice=2024&codeJournal=ALL&dateDeb=2024-01-01&dateFin=2024-12-31&nbcol=6&niveau=3&compteDeb=&compteFin=